module.exports = __webpack_public_path__ + "img/1024px-Next_Arrow.c19513b6.svg";